"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationEntityRefDto = instanceOfNotificationEntityRefDto;
exports.NotificationEntityRefDtoFromJSON = NotificationEntityRefDtoFromJSON;
exports.NotificationEntityRefDtoFromJSONTyped = NotificationEntityRefDtoFromJSONTyped;
exports.NotificationEntityRefDtoToJSON = NotificationEntityRefDtoToJSON;
exports.NotificationEntityRefDtoToJSONTyped = NotificationEntityRefDtoToJSONTyped;
/**
 * Check if a given object implements the NotificationEntityRefDto interface.
 */
function instanceOfNotificationEntityRefDto(value) {
    if (!('sportId' in value) || value['sportId'] === undefined)
        return false;
    if (!('teamId' in value) || value['teamId'] === undefined)
        return false;
    if (!('playerId' in value) || value['playerId'] === undefined)
        return false;
    if (!('matchId' in value) || value['matchId'] === undefined)
        return false;
    return true;
}
function NotificationEntityRefDtoFromJSON(json) {
    return NotificationEntityRefDtoFromJSONTyped(json, false);
}
function NotificationEntityRefDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportId': json['sportId'],
        'teamId': json['teamId'],
        'playerId': json['playerId'],
        'matchId': json['matchId'],
    };
}
function NotificationEntityRefDtoToJSON(json) {
    return NotificationEntityRefDtoToJSONTyped(json, false);
}
function NotificationEntityRefDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportId': value['sportId'],
        'teamId': value['teamId'],
        'playerId': value['playerId'],
        'matchId': value['matchId'],
    };
}
